import { useId, type ReactElement } from 'react';

import type { DocumentHealth } from '@/features/sgc-dashboard/use-document-health';
import { formatPctEs } from '@/features/sgc-dashboard/presentation';
import { plural } from '@/lib/plural';

// Barra de salud documental al pie del menú (so=430, spec §3.7; mockup 01): % de
// controlados vigentes y documentos vencidos, del resumen del panel. Sin porcentaje (no
// hay controlados) no se muestra.

export function SidebarHealth({ health }: { health: DocumentHealth }): ReactElement | null {
  const id = useId();
  if (health.currentPct === null) {
    return null;
  }
  return (
    <section className="health" aria-labelledby={id}>
      <div className="hk" id={id}>
        Cumplimiento documental
      </div>
      <div className="bar" aria-hidden="true">
        <i style={{ width: `${health.currentPct}%` }} />
      </div>
      <div className="hv">
        <b>{formatPctEs(health.currentPct)} %</b> vigente ·{' '}
        {plural(health.overdue, 'vencido', 'vencidos')}
      </div>
    </section>
  );
}
